import { UrlUtils } from "@allwyn/utils/url";

const redirectQueryString = UrlUtils.getQueryString("redirectWecoma");
UrlUtils.clearUrlParams(["redirectWecoma"]);

export const wecomaRedirectActive = redirectQueryString === "" || !!redirectQueryString;
